export type SortOrder = 'asc' | 'desc';

export interface Sort {
  column: string;
  order: SortOrder;
}

// This comes from Spring's Page object
export interface PageableContentAPI<T> {
  content: T[];
  last: boolean;
  total_pages: number;
  total_elements: number;
  number_of_elements: number;
  number: number;
  size: number;
  first: boolean;
  empty: boolean;
}

// This comes from Spring's Page object
export interface PageableContent<T> {
  content: T[];
  last: boolean;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  number: number;
  size: number;
  first: boolean;
  empty: boolean;
}

// Params expected for Spring's pagination
export interface PageRequest {
  page?: number;
  size?: number;
  sort?: Sort;
}

export const sortToParam = (sort: Sort): string => `${sort.column},${sort.order}`;

export const pageRequestToParams = (pageRequest: PageRequest): Record<string, string | number | undefined | null> => ({
  page: pageRequest.page || undefined,
  size: pageRequest.size || undefined,
  sort: pageRequest.sort ? sortToParam(pageRequest.sort) : undefined,
});
